import axios from 'axios';
import { useQuery } from 'react-query';
import { SortBy } from 'src/types/api-general';

import { Tag } from 'src/types/tag';

type TagResponse = {
  data: Tag;
};

// Tag
export function useTag(id: Tag['id']) {
  return useQuery<TagResponse, unknown, Tag>(
    ['tags', id],
    () => axios.get(`/api/tags/${id}`),
    {
      select: (data) => data.data,
    }
  );
}

type TagsResponse = {
  data: Tag[];
};
type UseTagsParams = {
  limit?: number;
  sort_by?: SortBy<keyof Tag>[];
  q?: string;
};
export function useTags(params: UseTagsParams = {}) {
  return useQuery<TagsResponse, unknown, Tag[]>(
    ['tags', params],
    () =>
      axios.get('/api/tags', {
        params: {
          ...params,
          sort_by: params.sort_by?.join(','),
        },
      }),
    {
      select: (data) => data.data,
    }
  );
}
